<template>
    <div class="payment__form">
        <form
            v-if="
                state.currentView == '1VOUCHER_INIT_VIEW' && state.processing != true
            "
            @submit.prevent="checkPhone"
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("voucher.init.instruction")}}
            </h5>

            <primary-input
                :title="$t('voucher.input.pin')"
                type="tel"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="password"
                placeholder="1234-5678-3456-9876"
                inputName="pin"
                :isRequired="getValueFromPath(state, 'inputs.voucher.required') || true"
                @value-change="voucher = $event"
                :is-voucher="true"
                :total-characters="19"
            />
            <primary-input
                type="tel"
                :title="$t('voucher.input.phone')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="07013926478"
                :defaultValue="getValueFromPath(state, 'inputs.phone.value') || null"
                :isRequired="getValueFromPath(state, 'inputs.phone.required') || true"
                @value-change="telephone = $event"
                inputName="phone"
                :number-only="true"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
            />
        </form>
        <div
            v-else-if="
                state.currentView == '1VOUCHER_CONFIRM_VIEW' && state.processing != true
            "
        >
            <div :class="[state.changeVoucher != null ? 'voucher-instructions' : '']">
               
                <div class="loader-container">
                    <div class="loader-wrapper">
                        <div class="loader-icon"  :class="[state.changeVoucher != null ? 'loader-icon-small' : '']"></div>
                    </div>
                </div>
                <h5
                    v-if="state.changeVoucher"
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{$t("voucher.transaction.status")}}
                </h5>

                <h5
                    v-else
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{$t("voucher.notification.message")}}
                </h5>
            </div>
            <div v-if="state.changeVoucher" class="account-box">
                <div class="account-box__field">
                    <label> {{$t("voucher.label.amount")}} </label>
                    <h4>
                        {{ state.changeVoucher.amount.currency }} 
                        {{ state.changeVoucher.amount.computed }}
                    </h4>
                </div>
                <div class="account-box__field">
                    <label> {{$t("voucher.label.serial")}} </label>
                    <h4>
                        {{ state.changeVoucher.serial }}
                    </h4>
                </div>
                <div class="account-box__field">
                    <label> {{$t("voucher.label.pin")}} </label>
                    <div class="account-copy">
                        <h4>
                            {{ state.changeVoucher.pin }}
                        </h4>
                        <copy-button :copyText="state.changeVoucher.pin" />
                    </div>
                </div>
                <div class="account-box__field">
                    <label> {{$t("voucher.label.expiry")}} </label>
                    <h4>
                        {{ state.changeVoucher.expiry }}
                    </h4>
                </div>
            </div>
            <PrimaryButton
                v-if="state.changeVoucher"
                :content="$t('voucher.save.btn')"
                @click="Next()"
            />
        </div>
    </div>
</template>

<script>
import { getValueFromPath } from "@/support/helpers";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
import CopyButton from "@/components/copy-button.vue";
// import PinInput from  "@/components/form/base-pin-input";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount } from "vue";
export default {
    name: "Voucher",
    components: {
    // PinInput,
        CopyButton,
        PrimaryInput,
        PrimaryButton,
    },
    setup() {
        const store = injectStore();

        const voucher = ref("");
        const checkoutData = ref(store.getState());
        const telephone = ref("");
        const transactionSuccessful = ref(false);

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function checkPhone() {
            if (telephone.value != "") step2();
        }

        function step2() {
            const cleanedVoucher = voucher.value.replace(/[\s-]+/g, "");
            const trimmedVoucher = cleanedVoucher.slice(0, 16);
            const data = { voucher: trimmedVoucher, phone: telephone.value };
            checkoutData.value.view.context.$actions.update(data);
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        onBeforeUnmount(() => {
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                changeVoucher: (state) =>
                    getValueFromPath(state, "view.context.changeVoucher") || null,
            }),
            voucher,
            getValueFromPath,
            telephone,
            transactionSuccessful,
            checkPhone,
            step2,
            Next,
        };
    },
};
</script>

<style scoped>
.voucher-instructions {
  /* display: flex; */
  align-items: flex-start;
}

.loader-icon-small {
  width: 4rem;
  height: 4rem;
}
.account-box{
    margin-top: 1vh;
    margin-bottom: 1vh;
}
.payment__instruction{
    margin: 0 2rem 3.8rem;
    text-align: left;
}
</style>